/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PassthroughConfigDto
 */
export interface PassthroughConfigDto {
    /**
     *
     * @type {number}
     * @memberof PassthroughConfigDto
     */
    passthroughConfigId?: number;
    /**
     * Optional when creating a passthrough
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    passthroughConfigSlug?: string;
    /**
     * The central system this config will pass through to
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    centralSystemId?: string;
    /**
     * Free text internal name
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    name?: string;
    /**
     * Free text user-facing name. Usually just the Central System name
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    publicName?: string;
    /**
     * Protocol used between illuminate and the third party Central System
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    protocol?: PassthroughConfigDtoProtocolEnum;
    /**
     * Defines which connection logic to use
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    passthroughType?: PassthroughConfigDtoPassthroughTypeEnum;
    /**
     * When false, no passthrough will occur, and it will be unavailable in the provisioning UI
     * @type {boolean}
     * @memberof PassthroughConfigDto
     */
    enabled?: boolean;
    /**
     * Default auth mode, which is preselected when adding a virtual device.
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    preferredAuthorizationMode?: PassthroughConfigDtoPreferredAuthorizationModeEnum;
    /**
     * The ordering of available passthroughs in the UI. Optional when creating a passthrough.
     * @type {number}
     * @memberof PassthroughConfigDto
     */
    rowSequence?: number;
    /**
     *
     * @type {Date}
     * @memberof PassthroughConfigDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof PassthroughConfigDto
     */
    updatedAt?: Date;
    /**
     * Url with scheme and optional port, eg 'wss://app.dev.somecpo.com:1234/ocpp/1.6/{deviceIdentity}'. No trailing slash.
     * @type {string}
     * @memberof PassthroughConfigDto
     */
    url?: string;
}

/**
 * @export
 */
export const PassthroughConfigDtoProtocolEnum = {
    Unknown: "Unknown",
    Ocpp16: "ocpp1.6",
    Jcwp18: "jcwp1.8",
    Jclp11: "jclp1.1",
    Jccp: "jccp",
    JcppPb: "jcpp-pb",
    Ocpp201: "ocpp2.0.1",
} as const;
export type PassthroughConfigDtoProtocolEnum =
    (typeof PassthroughConfigDtoProtocolEnum)[keyof typeof PassthroughConfigDtoProtocolEnum];

/**
 * @export
 */
export const PassthroughConfigDtoPassthroughTypeEnum = {
    Default: "Default",
    Readonly: "Readonly",
} as const;
export type PassthroughConfigDtoPassthroughTypeEnum =
    (typeof PassthroughConfigDtoPassthroughTypeEnum)[keyof typeof PassthroughConfigDtoPassthroughTypeEnum];

/**
 * @export
 */
export const PassthroughConfigDtoPreferredAuthorizationModeEnum = {
    LegacyBasicAuth: "LegacyBasicAuth",
    AutomaticBasicAuth: "AutomaticBasicAuth",
    ManualBasicAuth: "ManualBasicAuth",
    None: "None",
    Reject: "Reject",
} as const;
export type PassthroughConfigDtoPreferredAuthorizationModeEnum =
    (typeof PassthroughConfigDtoPreferredAuthorizationModeEnum)[keyof typeof PassthroughConfigDtoPreferredAuthorizationModeEnum];

/**
 * Check if a given object implements the PassthroughConfigDto interface.
 */
export function instanceOfPassthroughConfigDto(
    value: object,
): value is PassthroughConfigDto {
    return true;
}

export function PassthroughConfigDtoFromJSON(json: any): PassthroughConfigDto {
    return PassthroughConfigDtoFromJSONTyped(json, false);
}

export function PassthroughConfigDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): PassthroughConfigDto {
    if (json == null) {
        return json;
    }
    return {
        passthroughConfigId:
            json["passthroughConfigId"] == null
                ? undefined
                : json["passthroughConfigId"],
        passthroughConfigSlug:
            json["passthroughConfigSlug"] == null
                ? undefined
                : json["passthroughConfigSlug"],
        centralSystemId:
            json["centralSystemId"] == null
                ? undefined
                : json["centralSystemId"],
        name: json["name"] == null ? undefined : json["name"],
        publicName: json["publicName"] == null ? undefined : json["publicName"],
        protocol: json["protocol"] == null ? undefined : json["protocol"],
        passthroughType:
            json["passthroughType"] == null
                ? undefined
                : json["passthroughType"],
        enabled: json["enabled"] == null ? undefined : json["enabled"],
        preferredAuthorizationMode:
            json["preferredAuthorizationMode"] == null
                ? undefined
                : json["preferredAuthorizationMode"],
        rowSequence:
            json["rowSequence"] == null ? undefined : json["rowSequence"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        url: json["url"] == null ? undefined : json["url"],
    };
}

export function PassthroughConfigDtoToJSON(
    value?: PassthroughConfigDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        passthroughConfigId: value["passthroughConfigId"],
        passthroughConfigSlug: value["passthroughConfigSlug"],
        centralSystemId: value["centralSystemId"],
        name: value["name"],
        publicName: value["publicName"],
        protocol: value["protocol"],
        passthroughType: value["passthroughType"],
        enabled: value["enabled"],
        preferredAuthorizationMode: value["preferredAuthorizationMode"],
        rowSequence: value["rowSequence"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        url: value["url"],
    };
}
